/* Full-screen mobile navigation.
 *
 * On the native pages the sheet is authored inside the <details> in bc-product-header.liquid, so it
 * works with no JavaScript. It is moved to the body on adoption: a position:fixed element is only
 * viewport-sized if no ancestor creates a containing block, and the sticky header does - left in
 * place the sheet came out 375x72, the size of the header, with its content overflowing invisibly.
 *
 * Moving it also lets the page behind be locked while the sheet is open, and gives Escape and a link
 * tap somewhere sensible to close from.
 *
 * The imported concept pages - the homepage among them - draw their own header from the generated
 * runtime, so there is no Liquid to author a sheet into. Below 900px their nine-link row could not
 * fit: it wrapped to three lines, ran the header to 249px tall and laid Contact over Reviews.
 * buildFromConceptHeader() gives those pages the same disclosure, assembled from the links already
 * in their header, so one component serves the whole site.
 *
 * Nothing here holds a listener on the <details>. That runtime re-renders its header, and a
 * per-element `toggle` listener was silently dropped when it did - the element looked bound, the
 * disclosure opened, and the sheet never appeared. The open/close listener is on the document in
 * the CAPTURE phase instead: `toggle` does not bubble, but capture still reaches the target, so one
 * listener serves every disclosure however many times the header is rebuilt. The sheet itself lives
 * on <body>, out of the runtime's reach, and is found again by id.
 */
(function () {
  'use strict';

  var SHEET = 'data-bc-mobile-sheet';
  var counter = 0;
  var scrollLock = '';

  function sheetFor(details) {
    var id = details.getAttribute('data-bc-sheet');
    if (!id) return null;
    return document.querySelector('[' + SHEET + '="' + id + '"]');
  }

  function adopt(details) {
    // The id survives a re-render of the <details> along with the rest of its attributes, which is
    // exactly what makes this safe to call again on a rebuilt header.
    if (details.getAttribute('data-bc-sheet')) return;
    var sheet = details.querySelector('[' + SHEET + '], .bc-mobile-sheet');
    if (!sheet) return;

    var id = 'bc-sheet-' + ++counter;
    details.setAttribute('data-bc-sheet', id);
    sheet.setAttribute(SHEET, id);
    document.body.appendChild(sheet);
    sheet.hidden = !details.open;

    // A link tap navigates; closing first stops the sheet flashing over the new page on a back button.
    sheet.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('a')) {
        var owner = document.querySelector('[data-bc-sheet="' + id + '"]');
        if (owner) owner.open = false;
      }
    });
  }

  /* The sheet is fixed to the viewport while the header is sticky inside the page, so where the
   * header actually sits depends on what is above it and how far the page has scrolled - on the
   * concept pages an announcement strip sits above it at the top of the page. A fixed top padding
   * therefore put the first link underneath the header. Measure it instead. */
  function clearHeader(details, sheet) {
    var inner = sheet.firstElementChild;
    if (!inner) return;
    var header = details.closest('header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    if (bottom > 0) inner.style.paddingTop = Math.round(bottom + 20) + 'px';
  }

  function sync(details) {
    var sheet = sheetFor(details);
    if (!sheet) return;
    sheet.hidden = !details.open;
    if (details.open) clearHeader(details, sheet);
    if (details.open) {
      scrollLock = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      var first = sheet.querySelector('a');
      if (first) {
        window.setTimeout(function () {
          try { first.focus({ preventScroll: true }); } catch (error) { first.focus(); }
        }, 60);
      }
    } else {
      document.body.style.overflow = scrollLock;
    }
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || !details.matches || !details.matches('[data-bc-mobile-menu]')) return;
      sync(details);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-bc-mobile-menu][open]');
    if (!open) return;
    open.open = false;
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  function link(href, text, current) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    if (current) a.setAttribute('aria-current', 'page');
    return a;
  }

  /* Build the disclosure for a concept header out of what that header already links to, so the
   * sheet can never drift from the row it replaces. */
  /* The published programme, as the concept page rendered it. */
  function programme() {
    var el = document.querySelector('script[id^="BCConceptConfig"]');
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      return (cfg && cfg.props && cfg.props.programme) || null;
    } catch (e) {
      return null;
    }
  }

  function orderRow(meal, label, quiet) {
    if (!meal || meal.soldOut || meal.awaiting) return null;
    var product = meal.product || {};
    var href = product.url;
    if (!href) return null;
    var a = document.createElement('a');
    a.className = 'bc-cnav__order' + (quiet ? ' bc-cnav__order--quiet' : '');
    a.href = href;
    var name = document.createElement('span');
    name.textContent = label;
    a.appendChild(name);
    /* The programme publishes a bare number ("35.00"). The rest of the site writes it the way
     * money_without_trailing_zeros does - "$35" - so it is written that way here too. */
    var price = product.price || meal.price || '';
    if (price && /^[\d.,]+$/.test(String(price))) {
      price = '$' + String(price).replace(/\.00$/, '');
    }
    if (price) {
      var strong = document.createElement('strong');
      strong.textContent = price;
      a.appendChild(strong);
    }
    return a;
  }

  function buildOrders() {
    var prog = programme();
    if (!prog) return null;
    var rows = [
      orderRow(prog.friday, 'Order my Friday dinner for two', false),
      orderRow(prog.lasagna, 'Order Lasagna Sunday for two', true)
    ].filter(Boolean);
    if (!rows.length) return null;
    var wrap = document.createElement('div');
    wrap.className = 'bc-cnav__orders';
    rows.forEach(function (r) { wrap.appendChild(r); });
    return wrap;
  }

  function buildFromConceptHeader(header) {
    if (header.querySelector('[data-bc-mobile-menu]')) return;
    var row = header.firstElementChild;
    var nav = header.querySelector('nav');
    if (!row || !nav) return;

    var details = document.createElement('details');
    details.className = 'bc-cnav';
    details.setAttribute('data-bc-mobile-menu', '');

    var summary = document.createElement('summary');
    summary.setAttribute('aria-label', 'Menu');
    var bars = document.createElement('span');
    bars.className = 'bc-cnav__bars';
    bars.setAttribute('aria-hidden', 'true');
    var word = document.createElement('span');
    word.className = 'bc-cnav__word';
    word.textContent = 'Menu';
    summary.appendChild(bars);
    summary.appendChild(word);
    details.appendChild(summary);

    var sheet = document.createElement('div');
    sheet.className = 'bc-cnav__sheet';
    sheet.setAttribute(SHEET, '');
    var inner = document.createElement('div');
    inner.className = 'bc-cnav__inner';

    var sheetNav = document.createElement('nav');
    sheetNav.setAttribute('aria-label', 'Mobile navigation');
    /* Keyed on destination AND wording. Two entries can share a href and still be two different
     * things to look for - "Wine wall" and "Menu" both point at the menu page while the wine list
     * page is unpublished - and de-duplicating on the href alone quietly dropped one of them. */
    var seen = {};
    Array.prototype.slice.call(nav.querySelectorAll('a')).forEach(function (a) {
      var text = (a.textContent || '').trim();
      var key = a.href + '|' + text;
      if (!text || seen[key]) return;
      seen[key] = true;
      sheetNav.appendChild(link(a.getAttribute('href'), text, a.hasAttribute('aria-current')));
    });
    // The cluster on the right of the header - Contact, Reserve, the one pill - belongs here too.
    var cluster = row.querySelector(':scope > div');
    if (cluster) {
      Array.prototype.slice.call(cluster.querySelectorAll('a')).forEach(function (a) {
        var text = (a.textContent || '').trim();
        var key = a.href + '|' + text;
        if (!text || seen[key]) return;
        seen[key] = true;
        sheetNav.appendChild(link(a.getAttribute('href'), text, false));
      });
    }
    /* The two things people open this menu to do, first, priced. Read from the programme the page
     * already publishes, so a price here cannot drift from the product it links to. */
    var orders = buildOrders();
    if (orders) inner.appendChild(orders);

    inner.appendChild(sheetNav);

    /* The phone number is read off the page rather than written here, so there is one published
     * copy of it and this cannot quietly go stale. */
    var tel = document.querySelector('a[href^="tel:"]');
    if (tel) {
      var number = (tel.textContent || '').trim().replace(/^call( now)?\s*[··-]?\s*/i, '');
      var contact = document.createElement('div');
      contact.className = 'bc-cnav__contact';
      contact.appendChild(link(tel.getAttribute('href'), 'Call ' + number, false));
      inner.appendChild(contact);
    }

    sheet.appendChild(inner);
    details.appendChild(sheet);
    row.appendChild(details);
    adopt(details);
  }

  function scan() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-bc-mobile-menu], .bc-preorder-site-header__mobile-menu'))
      .forEach(function (details) {
        if (!details.hasAttribute('data-bc-mobile-menu')) details.setAttribute('data-bc-mobile-menu', '');
        adopt(details);
      });
    var conceptHeader = document.querySelector('.bc-concept-mount header');
    if (conceptHeader) buildFromConceptHeader(conceptHeader);
  }

  scan();

  /* Concept pages mount their header after this script runs, and rebuild it afterwards. Keep
   * watching: a rebuilt header needs its disclosure putting back, and re-adoption is a no-op when
   * nothing has changed. */
  if ('MutationObserver' in window) {
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
